import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import { HTTP_RESPONSE_CODE } from '../../constants/shared/ApiConstants';
import { SHOULD_VALIDATE_SESSION } from '../../constants/shared/CommonConstants';

// TODO: investigate why actions name FETCH_INTERCOM_INFO instead of FETCH_INTERCOM_INFO.FETCH_INTERCOM_INFO_ERROR
const FETCH_INTERCOM_INFO = 'FETCH_INTERCOM_INFO';

export const initialState = {
    [SHOULD_VALIDATE_SESSION]: false,
};

export const reducer = (state = initialState, action = {}) => {
    const { type, error } = action;
    const matches = /(.*)_(START|ERROR)/.exec(type);
    // not a *_START / *_ERROR actions, so we ignore them
    if (!matches) return state;
    const [, requestName, requestState] = matches;
    return {
        ...state,
        [SHOULD_VALIDATE_SESSION]:
            !!error && get(error, 'error.response.status') === HTTP_RESPONSE_CODE.UNAUTHORIZED,
        [requestName]: requestState === 'ERROR' ? error : '',
    };
};

const hasError = state =>
    Object.keys(state).some(
        action =>
            !isEmpty(state[action]) &&
            action !== SHOULD_VALIDATE_SESSION &&
            action !== FETCH_INTERCOM_INFO,
    );

const hasErrorExcludingUnauthorized = state =>
    Object.keys(state).some(
        action =>
            !isEmpty(state[action]) &&
            action !== SHOULD_VALIDATE_SESSION &&
            get(state[action], 'error.response.status') !== HTTP_RESPONSE_CODE.UNAUTHORIZED &&
            action !== FETCH_INTERCOM_INFO,
    );

const getError = state =>
    Object.keys(state)
        .filter(action => action !== SHOULD_VALIDATE_SESSION)
        .map(action => state[action])
        .find(error => !isEmpty(error));

const shouldValidateSession = state => state[SHOULD_VALIDATE_SESSION];

export const selectors = {
    hasError,
    getError,
    hasErrorExcludingUnauthorized,
    shouldValidateSession,
};
